
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinkargaon() {



const cardData = {
  keyword: 'Corporate Cab and Bus Services in Kargaon MIDC',
  heading: 'eTravo: Corporate Cab and Bus Services in Kargaon MIDC',
  headingDescription: `eTravo provides dependable and customized corporate cab and bus services in Kargaon MIDC, a steadily emerging industrial hub supporting a variety of manufacturing, logistics, and warehousing operations. With growing workforce demands in this area, we offer professional transportation solutions tailored to meet the commuting needs of employees, factory workers, and executives.`,

  top: 'Top Places to visit in Pune with eTravo',
"topPlaces": [
  {
    "title": "Khed City Industrial Park",
    "description": "Khed City is a 4,200-acre integrated industrial township developed by the Kalyani Group and MIDC. It hosts global and Indian companies like Mars International, Maxion Wheels, Amul, and Hyosung. eTravo provides tailored employee transportation solutions, ensuring efficient and timely commutes within this expansive industrial zone."
  },
  {
    "title": "Rajgurunagar (formerly Khed) Town Center",
    "description": "Rajgurunagar serves as the administrative headquarters of Khed Taluka. With its strategic location on the Pune-Nashik Highway, it is a hub for commerce and governance. eTravo offers reliable cab services for residents, officials, and visitors, facilitating smooth travel within and beyond the town."
  },
  {
    "title": "Hutatma Rajguru Mahavidyalaya",
    "description": "This prominent educational institution offers undergraduate and postgraduate programs in Arts, Commerce, and Science. eTravo ensures safe and punctual transportation for students and faculty, supporting academic pursuits in the region."
  },
  {
    "title": "Sahyadri School (Krishnamurti Foundation India)",
    "description": "Located near Tiwai Hill, Sahyadri School provides holistic education amidst nature. eTravo caters to the transportation needs of students and staff, ensuring comfortable travel to this serene campus."
  },
  {
    "title": "Dilawar Khan's Tomb and Mosque",
    "description": "A 17th-century Mughal-era monument, this site is a testament to the region's rich history. eTravo offers guided tour transportation services, allowing history enthusiasts to explore this architectural marvel conveniently."
  },
  {
    "title": "Khed Railway Station",
    "description": "Situated on the Konkan Railway line, Khed Railway Station connects the town to major cities. eTravo provides seamless first and last-mile connectivity, ensuring travelers reach their destinations on time."
  },
  {
    "title": "Chas-Kaman Dam",
    "description": "A vital water reservoir near Khed, it supports irrigation and water supply in the region. eTravo facilitates visits for professionals and tourists interested in environmental and infrastructural studies."
  },
  {
    "title": "Government ITI Khed",
    "description": "This Industrial Training Institute offers vocational courses, enhancing skill development in the area. eTravo supports students with dependable transportation options, aiding in their educational journey."
  },
  {
    "title": "Khed Bus Stand",
    "description": "A central hub for road transport, connecting Khed to various parts of Maharashtra. eTravo complements public transport by offering flexible cab services for travelers and daily commuters."
  },
  {
    "title": "Local Markets and Commercial Areas",
    "description": "Khed's bustling markets are centers of trade and daily life. eTravo provides convenient transportation for shoppers and business owners, ensuring easy access to these commercial zones."
  }
],

services: [
  {
    name: 'Kargaon MIDC Corporate Transport',
    description: `End-to-end corporate transport services for companies operating in Kargaon MIDC. Designed for daily employee and executive travel, with flexible scheduling, professional drivers, and scalable monthly plans.`
  },
  {
    name: 'Staff Shuttle & Commute Services Kargaon',
    description: `Reliable shuttle and commute services for staff in the Kargaon industrial area. Our fleet of minibuses and cabs supports shift-based transport with optimized routes and punctual operations.`
  },
  {
    name: 'AC Bus & Cab Rentals for Industries in Kargaon',
    description: `Monthly AC cab and bus rentals tailored for industrial use in Kargaon. Offers clean, well-maintained vehicles and courteous drivers to ensure a safe, comfortable commute for staff and management.`
  },
  {
    name: 'Daily Employee Transport Solutions Kargaon MIDC',
    description: `Daily transport solutions built for the workforce in Kargaon MIDC. Includes fixed or flexible routes, shift alignment, and real-time support to ensure seamless employee mobility.`
  },
  {
    name: 'Cost-Effective Corporate Travel Kargaon',
    description: `Affordable corporate travel options for businesses in Kargaon. Our monthly packages reduce operational costs while maintaining high service quality across employee and executive transport.`
  },
  {
    name: 'Reliable Pickup & Drop Services in Kargaon',
    description: `Punctual and dependable pickup and drop services for companies in Kargaon. Ideal for daily employee transport across shifts, with tracked vehicles and safety-focused operations.`
  }
],

tableData: [
  ['Kargaon MIDC Corporate Transport', 'Staff Shuttle & Commute Services Kargaon'],
  ['AC Bus & Cab Rentals for Industries in Kargaon', 'Daily Employee Transport Solutions Kargaon MIDC'],
  ['Cost-Effective Corporate Travel Kargaon', 'Reliable Pickup & Drop Services in Kargaon']
],




"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab and Bus Services in Kargaon MIDC",
    "WhyChoosedescription": "eTravo provides efficient and dependable cab and bus services for businesses operating in Kargaon MIDC, ensuring smooth and timely employee transportation solutions."
  },
  {
    "WhyChooseheading": "Fleet Solutions for Industrial and Corporate Commutes",
    "WhyChoosedescription": "Our fleet includes a wide selection of sedans, SUVs, and buses to handle daily commuting needs for both staff and executives in the Kargaon MIDC area."
  },
  {
    "WhyChooseheading": "Shift-Compatible Transport Services",
    "WhyChoosedescription": "We specialize in transport services aligned with factory and corporate shift patterns, ensuring reliable employee movement across all work hours."
  },
  {
    "WhyChooseheading": "Trained Drivers with Local Expertise",
    "WhyChoosedescription": "Our drivers are experienced and well-acquainted with Kargaon MIDC routes, providing safe, punctual, and efficient travel every day."
  },
  {
    "WhyChooseheading": "GPS Tracking for Live Vehicle Monitoring",
    "WhyChoosedescription": "All vehicles are GPS-enabled for real-time location tracking, offering added safety and route transparency to transport managers."
  },
  {
    "WhyChooseheading": "Clear and Transparent Monthly Billing",
    "WhyChoosedescription": "We provide easy-to-understand monthly invoices with detailed ride data, supporting accurate cost tracking and budget control."
  },
  {
    "WhyChooseheading": "Sanitized Vehicles Ensuring Hygiene and Safety",
    "WhyChoosedescription": "Our vehicles are regularly cleaned and sanitized, upholding the highest hygiene and safety standards for your employees."
  },
  {
    "WhyChooseheading": "Dedicated Transport Management Support",
    "WhyChoosedescription": "A dedicated account manager coordinates your transport operations in Kargaon MIDC, ensuring consistent service quality and timely assistance."
  }
]

















}

const faqData = [
  [
    {
      question: "Which areas do your corporate cab and bus services cover?",
      answer: "We offer corporate transportation services in Pune and surrounding industrial regions, including Kargaon MIDC, Chakan, Ranjangaon, and nearby zones."
    },
    {
      question: "Can transport plans be customized for different shifts and workforce sizes?",
      answer: "Yes, our services are flexible and tailored to meet your company’s shift schedules, employee numbers, and preferred routes."
    },
    {
      question: "Do you provide GST-compliant billing for corporate clients?",
      answer: "Absolutely. We provide consolidated monthly invoices that are GST-compliant, along with detailed trip and usage reports."
    },
    {
      question: "Are trained and verified drivers included in the service?",
      answer: "Yes, all our drivers are background-verified, professionally trained, and familiar with corporate transport needs."
    },
    {
      question: "What safety protocols are followed for employee transportation?",
      answer: "Our fleet is GPS-enabled, sanitized regularly, and maintained to high safety standards. Drivers undergo strict verification and training."
    },
    {
      question: "Is dedicated support provided for daily transportation management?",
      answer: "Yes, we assign dedicated transport coordinators and provide live tracking tools to ensure smooth daily commute operations."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Rajiv Kulkarni",
    designation: "Admin Manager, Kargaon MIDC Manufacturing",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s corporate transport service in Kargaon MIDC is dependable and efficient. Our employees’ daily commute has never been smoother.”"
  },
  {
    name: "Ms. Sneha Patil",
    designation: "HR Head, Kargaon Industrial Solutions",
    rating: [1, 1, 1, 1, 1],
    text: "“The team at eTravo provides excellent support and customized transport solutions tailored for Kargaon MIDC’s industrial needs.”"
  }
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Kargaon MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-kargaon.jpg",
  "description": "Book corporate cab and bus services in Kargaon MIDC with eTravo for staff shuttle, daily employee transport, and reliable pickup & drop services. Affordable and professional AC cabs and buses tailored for industries in Kargaon.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5657"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-kargaon-midc"
  }
};






    return (
        <div>


<Helmet>
  <title>Corporate Cab and Bus Services in Kargaon MIDC | Staff Transport & Office Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Kargaon MIDC with eTravo for staff shuttle, employee transport, and cost-effective corporate travel. Reliable AC cabs and buses for industries in Kargaon." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/103.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinkargaon;